import { Form, Input } from "antd";

export const MIN_PASSWORD_LENGTH = 10;

const NewPasswordFields: React.FC = () => (
  <>
    <Form.Item
      label="New password"
      name="password"
      rules={[
        { required: true, message: "Choose a password" },
        { min: MIN_PASSWORD_LENGTH, message: `Use at least ${MIN_PASSWORD_LENGTH} characters` },
      ]}
      hasFeedback
    >
      <Input.Password autoComplete="new-password" />
    </Form.Item>
    <Form.Item
      label="Repeat password"
      name="confirm"
      dependencies={["password"]}
      hasFeedback
      rules={[
        { required: true, message: "Repeat the password" },
        ({ getFieldValue }) => ({
          validator: (_, value) =>
            !value || getFieldValue("password") === value
              ? Promise.resolve()
              : Promise.reject(new Error("The passwords do not match")),
        }),
      ]}
    >
      <Input.Password autoComplete="new-password" />
    </Form.Item>
  </>
);

export default NewPasswordFields;
